import React from "react";
import Footer from '../../containers/landingPage/Footer';
import MeetingBanner from '../../components/landingPage/MeetingBanner';
import PartnerSection from '../../containers/landingPage/Professional/PartnerSection';
import NetworkSection from '../../containers/landingPage/Professional/NetworkSection';
import PartnerBenefits from "../../containers/landingPage/Professional/PartnerBenefits";
import WorkflowSection from "../../containers/landingPage/Professional/WorkflowSection"
import CTASection from "../../containers/landingPage/Professional/CTASection";
import TestimonialsPro from "../../containers/landingPage/Professional/TestimonialsPro";
import ServicesSection from "../../containers/landingPage/Professional/ServicesSection";
import MainBanner from "../../components/landingPage/MainBanner/Slides/Professional/MainBannerPro";
import HeaderNavbar from "../../containers/landingPage/HeaderNavbar";
import GoDigital from "../../containers/landingPage/Professional/GoDigitalPro";
import ContactUsSection from "../../containers/landingPage/ContactUsSection"
import ClinicsProvider from "../../store/clinics/clinicsProvider";


const LandingPage = () => {
  
  return (
    <div className="text-lg">
      <HeaderNavbar dark logo=' white' professional/>
      <MainBanner/>
      <NetworkSection />
      <GoDigital/>
      <WorkflowSection />
      <PartnerSection />
      <MeetingBanner />
      <ServicesSection />
      <PartnerBenefits />
      <TestimonialsPro />
      <CTASection />
      <ClinicsProvider>
        <ContactUsSection/>
      </ClinicsProvider>
      <Footer dark/>
    </div>
  )
}

export default LandingPage;